// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2Z7Dr","amount":"Amount_amount__20KCW","tip":"Amount_tip__1_5QA","tipHeader":"Amount_tipHeader__2eM5q","tipsWrap":"Amount_tipsWrap__3m1pn"};